<!--班级空间-表格 Sag 2020-04-16-->
<template>
  <div class="its-data-table" :class="[user?user.userType:'']">
    <el-table ref="multipleTable" :data="DataList" tooltip-effect="dark" style="width: 100%" row-key="id" @selection-change="handleSelectionChange" @cell-mouse-enter="cellMouseEnter" @cell-mouse-leave="cellMouseLeave" :default-sort="defaultSort" @sort-change="tableSortChange">
      <el-table-column type="selection" width="60" align="center" :reserve-selection="true" class-name="selectColumn">
      </el-table-column>
      <el-table-column label="文件名" prop="name" width="600">
        <template slot-scope="scope">
          <div slot="aside" class="its-name" data-io-click="tracker" @click="fileNameAction(scope.row)">
            <i class="type-icon xs" :class="[scope.row.folder?'file':scope.row.fileSuffix]"></i>
            <el-tooltip effect="dark" placement="top" :content="scope.row.fileName">
              <span>{{ scope.row.fileName }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="大小" width="120" align="center" sortable="custom" prop="fileSize" show-overflow-tooltip>
        <template slot-scope="scope">
          <template v-if="scope.row.mouseEnter"></template>
          <template v-else>
            <span v-if="scope.row.folder">-</span>
            <span v-else>{{scope.row.fileSize | fileSizeName}}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="gmtModified" label="创建时间" width="200" sortable="custom" show-overflow-tooltip>
        <template slot-scope="scope">
          <template v-if="scope.row.mouseEnter"></template>
          <template v-else>{{ scope.row.gmtCreate }}</template>
        </template>
      </el-table-column>
      <el-table-column label="可见班级" width="220" class-name="classListColumn">
        <template slot-scope="scope">
          <div v-if="scope.row.mouseEnter">
            <i v-if="!scope.row.folder" class="its-icon its-icon-download" @click="downloadFile(scope.row)" data-io-click="tracker"></i>
            <span v-if="user&&user.userType=='TEACHER'" class="its-icon its-icon-gengduo" @mouseenter="scope.row.hover=true" @mouseleave="scope.row.hover=false">
              <div v-if="scope.row.hover" role="tooltip" id="el-popover-5117" aria-hidden="false" class="el-popover el-popper more-option" :class="[scope.row.folder?'left-46':'left-10']" tabindex="0" style="position: absolute; transform-origin: center top; z-index: 2003;" x-placement="bottom">
                <ul class="popover-filter-ul">
                  <li v-if="!scope.row.folder" data-io-click="tracker" class="popover-filter-li" @click="moreOptions('edit', scope.row)">
                    <i style="font-style: normal;">修改可见班级</i>
                  </li>
                  <li class="popover-filter-li" data-io-click="tracker" @click="moreOptions('move', scope.row)">
                    <i style="font-style: normal;">移动到</i>
                  </li>
                  <li class="popover-filter-li" data-io-click="tracker" @click="moreOptions('rename', scope.row)">
                    <i style="font-style: normal;">重命名</i>
                  </li>
                  <li v-if="user&&user.userType=='TEACHER'" class="popover-filter-li" data-io-click="tracker" @click="deleteItem(scope.row)">
                    <i style="font-style: normal;">删除</i>
                  </li>
                </ul>
                <div x-arrow="" class="popper__arrow" style="left: 67.5px;"></div>
              </div>
            </span>
          </div>
          <template v-else>
            <div v-if="scope.row.folder" class="its-option-null">-</div>
            <div v-else class="its-option-null">
              <template v-if="scope.row.shareClazzList&&scope.row.shareClazzList.length==0">-</template>
              <template v-else>
                <div class="its-share-class-str">{{scope.row.shareClazzListStr}}</div>
              </template>
            </div>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="page.total > page.size || page.size <= 0" :page-size="page.size" :total-count="page.total" :current-page="page.current ? page.current : 1" :father-action="pageAction"></pagination>
    <div-no-data v-if="tableData.length==0" class="no-data">
      <p class="empty">暂无数据</p>
    </div-no-data>
    <move-to-dialog ref="moveToDialog" :treeData="treeData" :defaultProps="defaultProps" :title="title" :dialogVisible="dialogVisible" :defaultCheckedKeys="defaultCheckedKeys" :father-action="moveToAction"></move-to-dialog>
    <create-dialog :type="optionType" :item="item" :dialogVisible="createDialogVisible" :father-action="createAction"></create-dialog>
    <modify-class-dialog :items="items" :list="list" :dialogVisible="modifyDialogVisible" :father-action="modifyAction"></modify-class-dialog>
    <preview v-if="showPreview" :previewParams="previewParams" :previewRaw="previewRaw" :father-action="previewAction"></preview>
  </div>
</template>
<script>
import MoveToDialog from './MoveToDialog'
import CreateDialog from './CreateDialog'
import ModifyClassDialog from './ModifyClassDialog'
import Preview from './Preview'
import { classSpaceApi } from '../../../../utils/api'
import DivNoData from '../../../components/DivNoData'
import Pagination from './Pagination'
export default {
  name: 'DataTable',
  components: {
    MoveToDialog,
    CreateDialog,
    ModifyClassDialog,
    Preview,
    DivNoData,
    Pagination
  },
  props: {
    checkedItems: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    fatherAction: {
      type: Function,
      default: null
    },
    defaultSort: {
      type: Object,
      default: function () {
        return {
          prop: 'gmtModified',
          order: 'descending'
        }
      }
    },
    page: {
      type: Object,
      default: function () {
        return {
          total: 0,
          size: 2,
          current: 1
        }
      }
    }
  },
  data() {
    return {
      showPreview: false,
      previewParams: { id: '699', service: 'DOCUMENT', full: true, provider: 'I_CLASS' },
      previewRaw: { mime: 'doc', title: 'sdsd.doc' },
      list: [],
      treeData: [
        {
          id: 0,
          fileName: '全部文件',
          children: []
        }
      ],
      defaultProps: {
        label: 'fileName',
        children: 'children'
      },
      items: [],
      modifyDialogVisible: false,
      item: {},
      optionType: 'rename',
      createDialogVisible: false,
      title: '移动到',
      dialogVisible: false,
      DataList: [],
      defaultCheckedKeys: 0,
      selectedItem: {},
      popoverData: {
        type: 'more-option',
        title: '',
        items: [
          {
            type: 'edit',
            name: '修改可见班级'
          },
          {
            type: 'move',
            name: '移动到'
          },
          {
            type: 'rename',
            name: '重命名'
          }
        ]
      }
    }
  },
  mounted() {

  },
  computed: {
    user: function () {
      return this.$store.state.user
    }
  },
  methods: {
    getTreeDatas: function (params, node) {
      console.log(params, node)
      classSpaceApi.getFolderList(params).then((res) => {
        console.log(res)
        if (res.success) {
          let result = res.body
          if (!result) {
            this.$message.error('抱歉！您不能将自己任教科目以外的资源分享到班级空间！')
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleSelectionChange: function (val) {
      // this.multipleSelection = val;
      let selectedItems = []
      val.forEach((select) => {
        selectedItems.push(select.id)
      })
      this.$emit('selectedItems', selectedItems)
    },
    cellMouseEnter: function (row) {
      row.mouseEnter = true
      this.selectedItem = JSON.parse(JSON.stringify(row))
      row.createTime = ''
    },
    cellMouseLeave: function (row) {
      row.mouseEnter = false
      row.createTime = this.selectedItem.createTime
      this.DataList = JSON.parse(JSON.stringify(this.DataList))
    },
    moreOptions: function (type, item) {
      this.item = item
      if (type === 'move') {
        this.defaultCheckedKeys = this.$parent.searchParams.fileId
        this.dialogVisible = true
      } else if (type === 'rename') {
        this.optionType = 'rename'
        this.createDialogVisible = true
      } else if (type === 'edit') {
        this.items = item.shareClazzList
        this.list = this.$parent.shareClassList
        console.log('shareList', this.list)
        this.modifyDialogVisible = true
      }
    },
    moveToAction: function (data) {
      if (data.type === 'close') {
        this.dialogVisible = false
      } else if (data.type === 'nodeClick') {
        if (!data.item.children || data.item.children.length == 0) {
          let params = {
            subjectId: this.$parent.subject.id,
            parentId: data.item.id
          }
          this.getTreeDatas(params, data.item)
        }
      } else if (data.type === 'ok') {
        this.moveFile(data.item)
      }
    },
    createAction: function (data) {
      if (data.type === 'close') {
        this.createDialogVisible = false
      } else if (data.type === 'ok') {
        this.reNameFile(data)
      }
    },
    modifyAction: function (data) {
      if (data.type === 'close') {
        this.modifyDialogVisible = false
      } else if (data.type === 'ok') {
        this.changeClass(data)
      }
    },
    fileNameAction: function (item) {
      if (!item.folder) {
        //文件预览
        if (item.sourceId === 0) {
          this.$message.warning('资料正在同步中，请稍后')
          return
        }
        let type = item.fileSuffix
        if (type == 'rar' || type == 'other') {
          console.log('不支持预览')
          this.$message.warning('该文件不支持预览')
          return
        } else {
          classSpaceApi.getClassSpaceFileById(item.id).then(resp => {
            this.previewParams = {
              id: resp.body.sourceId,
              service: 'DOCUMENT',
              full: true,
              provider: item.provider
            }
            this.previewRaw = {
              mime: type,
              title: item.fileName,
              item: item
            }
            this.showPreview = true

          })
        }
      }
      // 点击文件名，判断操作
      if (this.fatherAction) {
        this.fatherAction({ type: 'name-click', item: item })
      }
    },
    deleteItem: function (data) {
      console.log(data)
      this.$confirm('确定要删除这个文件吗？删除后将无法恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'cs-delete-dialog'
      }).then(() => {
        this.deleteFile(data)
      }).catch(() => {
      });
    },
    editItem: function (item) {
      // 统计用户编辑行为
      let params = {
        sourceId: item.sourceId,
        classSpaceAction: 'EDIT'
      }
      classSpaceApi.calcUserAction(params)
      // 编辑
      const url = 'index.html#/platform/wps-edit/' + item.sourceId + '/edit?name=' + encodeURIComponent(item.fileName) +
        '&bizId=' + item.id
      window.open(url, '_blank')
    },
    toggleSelection: function (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    moveFile: function (data) {
      //要判断：文件夹不能移入自己或自己的子文件夹
      console.log('parent', data)
      console.log('target', this.item)
      if (data.id == this.item.id || data.filePath.indexOf(this.item.id) >= 0) {
        this.$message.error('文件夹不能移入自己或自己的子文件夹')
        return
      }
      let params = {
        fileIds: [{
          id: this.item.id,
          filePath: this.item.filePath
        }],
        parentId: data.id,
        filePath: data.filePath
      }
      classSpaceApi.moveFile(params).then((res) => {
        if (res.success) {
          this.$message.success('移动成功')
          this.dialogVisible = false
          this.$parent.getDataList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    deleteFile: function (data) {
      classSpaceApi.deleteFile([data.id]).then((res) => {
        if (res.success) {
          this.$message.success('删除成功')
          this.$parent.getDataList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    reNameFile: function (params) {
      params.item.fileName = params.fileName
      classSpaceApi.changeFileName(params.item).then((res) => {
        if (res.success) {
          this.$message.success('重命名成功')
          this.createDialogVisible = false
          this.$parent.getDataList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    changeClass: function (params) {
      params.items.forEach((item) => {
        item.fileId = this.item.id
      })
      //修改可见班级
      classSpaceApi.changeClass(params.items).then((res) => {
        if (res.success) {
          this.$message.success('修改可见班级成功')
          this.modifyDialogVisible = false
          this.$parent.getDataList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    downloadFile: function (item) {
      if (item.sourceId === 0) {
        this.$message.warning('资料正在同步中，请稍后')
        return
      }
      classSpaceApi.downloadFile(item.sourceId).then((res) => {
        console.log(res)
        if (res.success) {
          let url = res.body.url
          window.location.href = url
        } else {
          this.$message.error(res.message)
        }
      })
    },
    previewAction: function (data) {
      if (data.type === 'close') {
        this.showPreview = false
      }
    },
    pageAction: function (page) {
      if (this.fatherAction) {
        this.fatherAction({ type: 'page', data: page })
      }
    },
    clearSelections: function () {
      this.$refs.multipleTable.clearSelection()
    },
    tableSortChange: function (column) {
      //表格排序
      if (this.fatherAction) {
        this.fatherAction({ type: 'sort', item: column })
      }
    },
    setDefaultSort: function (sort) {
      // 设置默认排序
      if (!sort) {
        sort = {
          prop: 'gmtModified',
          order: 'descending'
        }
      }
      // this.defaultSort = sort
      this.$refs.multipleTable.clearSort()
      for (let i of this.$refs.multipleTable.columns) {
        if (i.property === sort.prop) {
          i.order = sort.order
        } else {
          i.order = ''
        }
      }
    }
  },
  watch: {
    user: {
      handler: function () {
        if (this.user) {
          let checkedList = []
          if (this.checkedItems.length > 0) {
            checkedList = JSON.parse(JSON.stringify(this.checkedItems))
          } else {
            checkedList = []
          }
          this.DataList.forEach((item) => {
            if (checkedList.indexOf(item.id) >= 0) {
              this.$refs.multipleTable.toggleRowSelection(item, true)
            }
          })
        }
      },
      immediate: true,
      deep: true
    },
    tableData: {
      handler: function () {
        this.tableData.forEach((item) => {
          item.mouseEnter = false
          item.hover = false
        })
        this.DataList = JSON.parse(JSON.stringify(this.tableData))
        this.DataList.forEach((item) => {
          let names = []
          if (item.shareClazzList) {
            item.shareClazzList.forEach((share) => {
              names.push(share.gradeName + share.className)
            })
          }
          item.shareClazzListStr = names.join('、')
        })
      },
      immediate: true,
      deep: true
    },
    showPreview: function () {
      this.$emit('show-preview', this.showPreview)
    }
  }
}
</script>
<style>
.more-option {
  top: 30px !important;
}
.left-26 {
  left: 26px;
}

.left-10 {
  left: -10px;
}

.left-46 {
  left: -47px;
  top: 27px !important;
}
</style>
<style scoped>
.its-data-table >>> .popover-filter-li:hover,
.its-data-table >>> .popover-filter-li.active {
  background-color: #f5f5f5;
  color: #2695ff;
}
.its-data-table >>> .popover-filter-li {
  margin: 0px -11px 4px -11px;
  padding: 5px 10px;
  max-height: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  color: #999999;
  cursor: pointer;
  text-align: center;
}
.its-data-table >>> .el-popper[x-placement^="bottom"] {
  margin-top: 9px;
}
.its-data-table >>> .el-table,
.its-data-table >>> .el-table__append-wrapper,
.its-data-table >>> .el-table__body-wrapper {
  overflow: visible;
}
.its-data-table {
  padding-bottom: 120px;
  position: relative;
}
.no-data {
  position: absolute;
  min-height: 300px;
  background: white;
  width: 100%;
  top: 60px;
  z-index: 1;
}
.its-icon {
  margin: 0 10px;
  cursor: pointer;
}
.its-icon:hover {
  color: #5591fe;
}
.its-name {
  cursor: pointer;
}
.its-name span {
  margin-left: 5px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 540px;
  vertical-align: bottom;
}
.its-name span:hover {
  color: #5591fe;
}
.its-share-class-str {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<style>
.STUDENT .selectColumn .el-checkbox,
.STUDENT .classListColumn .its-option-null,
.STUDENT thead .classListColumn > div {
  visibility: hidden;
}
</style>
